<template>
  <div class="pic_box" ref="pic_container">
    <template v-if="type==1">
      <div v-if="images.length==1" class="po_imgs pic_count_1">
        <div class="pic_item" :style="'background-image:url('+images[0].url+');'+(images[0].w > deviceWidth ? 'width:'+deviceWidth+'px;height:'+deviceWidth/(images[0].w / images[0].h)+'px;' : '')" @click.stop="onReadPoImg(0)"></div>
      </div>
      <div v-if="images.length==2" class="po_imgs pic_count_2">
        <div v-for="(item,index) in images" class="pic_item" :key="index" :style="'background-image:url('+item.url+')'" @click.stop="onReadPoImg(index)"></div>
      </div>
      <div v-if="images.length==3" class="po_imgs pic_count_3">
        <div v-for="(item,index) in images" class="pic_item" :key="index" :style="'background-image:url('+item.url+')'" @click.stop="onReadPoImg(index)"></div>
      </div>
      <div v-if="images.length==4" class="po_imgs pic_count_4">
        <div v-for="(item,index) in images" class="pic_item" :key="index" :style="'background-image:url('+item.url+')'" @click.stop="onReadPoImg(index)"></div>
      </div>
      <div v-if="images.length==5" class="po_imgs pic_count_5">
        <div v-for="(item,index) in images" class="pic_item" :class="index>1?'row_2':''" :key="index" :style="'background-image:url('+item.url+')'" @click.stop="onReadPoImg(index)"></div>
      </div>
      <div v-if="images.length==6" class="po_imgs pic_count_6">
        <div class="row_1">
          <div class="pic_1 pic_item" :style="'background-image:url('+images[0].url+')'" @click.stop="onReadPoImg(index)"></div>
          <div>
            <div v-if="index>0&&index<3" v-for="(item,index) in images" class="pic_item" :key="index" :style="'background-image:url('+item.url+')'" @click.stop="onReadPoImg(index)"></div>
          </div>
        </div>
        <div class="row_2">
          <div v-if="index>2" v-for="(item,index) in images" class="pic_item" :key="index" :style="'background-image:url('+item.url+')'" @click.stop="onReadPoImg(index)"></div>
        </div>
      </div>
      <div v-if="images.length==7" class="po_imgs pic_count_7">
        <div v-for="(item,index) in images" class="pic_item" :class="index==0?'pic_1':''" :key="index" :style="'background-image:url('+item.url+')'" @click.stop="onReadPoImg(index)"></div>
      </div>
      <div v-if="images.length==8" class="po_imgs pic_count_8">
        <div v-for="(item,index) in images" class="pic_item" :class="index>1?'row_2':''" :key="index" :style="'background-image:url('+item.url+')'" @click.stop="onReadPoImg(index)"></div>
      </div>
      <div v-if="images.length==9" class="po_imgs pic_count_9">
        <div v-for="(item,index) in images" class="pic_item" :key="index" :style="'background-image:url('+item.url+')'" @click.stop="onReadPoImg(index)"></div>
      </div>
    </template>
    <template v-if="type==2">
      <div v-if="images.length" class="po_imgs pic_count_1">
        <div class="pic_item video" :style="'background-image:url('+images[0].url+')'" @click.stop="onOpenVideo(images[1].url)">
          <div class="play_btn"></div>
        </div>
      </div>
    </template>
    <div class="video_wrap" v-if="ifOpenVideo" @click.self="closeVideo">
      <video :src="videoSrc" controls="controls"></video>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../assets/scss/mixin.scss";
.po_imgs {
  margin-top: 30px;
  .pic_item {
    background-color: #eee;
    margin-top: 4px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    .play_btn {
      width: 100%;
      height: 100%;
      background: url(./images/poIcPlay@2x.png) no-repeat center center / 112px
        auto;
    }
  }
  &.pic_count_1 {
    .pic_item {
      width: 343px;
      height: 343px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }
  }

  &.pic_count_2 {
    display: flex;
    justify-content: space-between;
    .pic_item {
      width: 343px;
      height: 343px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }
  }

  &.pic_count_3 {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .pic_item {
      width: 228px;
      height: 228px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }
  }

  &.pic_count_4 {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .pic_item {
      width: 343px;
      height: 343px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }
  }

  &.pic_count_5 {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .pic_item {
      width: 343px;
      height: 343px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      &.row_2 {
        width: 228px;
        height: 228px;
      }
    }
  }

  &.pic_count_6 {
    .row_1 {
      display: flex;
      justify-content: space-between;
      .pic_1 {
        width: 458px;
        height: 458px;
      }
    }
    .pic_item {
      width: 228px;
      height: 228px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }

    .row_2 {
      display: flex;
      justify-content: space-between;
    }
  }

  &.pic_count_7 {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .pic_item {
      width: 228px;
      height: 228px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      &.pic_1 {
        width: 690px;
        height: 343px;
      }
    }
  }

  &.pic_count_8 {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .pic_item {
      width: 343px;
      height: 343px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      &.row_2 {
        width: 228px;
        height: 228px;
      }
    }
  }

  &.pic_count_9 {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .pic_item {
      width: 228px;
      height: 228px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }
  }
}
.video_wrap {
  width: 100%;
  height: 100%;
  background: #000;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  video {
    margin: 0 auto;
    max-width: 100%;
  }
}
</style>

<script>
export default {
  data() {
    return {
      ifOpenVideo: false,
      videoSrc: "",
      deviceWidth: 750
    };
  },
  computed: {},
  mounted() {
    this.deviceWidth = this.$refs.pic_container.clientWidth;
  },
  props: {
    images: {
      type: Array,
      default: function() {
        return [];
      }
    },
    type: {
      type: String,
      default: "1"
    }
  },
  methods: {
    // 查看po图片
    onReadPoImg(pic_index) {
      let self = this;
      let urls = [];
      let imgs = self.images;
      let curUrl = imgs[pic_index].hd_url;
      imgs.forEach(function(item) {
        urls.push(item.hd_url);
      });
      wx.previewImage({
        current: curUrl, // 当前显示图片的http链接
        urls: urls // 需要预览的图片http链接列表
      });
    },
    onOpenVideo(url) {
      let self = this;
      self.videoSrc = url;
      self.ifOpenVideo = true;
    },
    closeVideo() {
      this.ifOpenVideo = false;
    }
  }
};
</script>




// WEBPACK FOOTER //
// PicBox.vue?640db679